import { useLanguage } from "../lang/LanguageContext";
import Header from "../components/Header";

export default function Softwares() {
  const { strings } = useLanguage();
  const soft = strings.software.list;

  return (
    <main className="min-h-screen bg-white text-gray-900 font-sans mb-12">
      <Header />
      <h1 className="text-3xl font-bold text-center px-6 pt-12 mb-12">
        {strings.software.title}
      </h1>

      {/* Grid for projects */}
      <div className="max-w-6xl mx-auto px-6 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {soft.map((item, index) => (
          <div
            key={index}
            className="border rounded-lg p-6 shadow hover:shadow-lg transition bg-white flex flex-col"
          >
            {/* Project title + language */}
            <h2 className="text-xl font-semibold mb-2">{item.name}</h2>
            <div className="flex items-center space-x-2 mr-4 mb-2">
              <img
                src={item.logo}
                alt={`${item.language} logo`}
                className="w-6 h-6 bg-transparent"
                style={{ backgroundColor: "transparent" }}
              />
              <span>{item.language}</span>
            </div>

            {/* Description */}
            <p className="text-gray-700 flex-grow">{item.description}</p>

            {/* Link */}
            <div className="mt-4">
              {item.url ? (
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline font-medium"
                >
                  {strings.software.visit}
                </a>
              ) : (
                <span className="text-gray-500">
                  {strings.software.default}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}
